<template>
  <div class="business">
    <menuBox :step="2"></menuBox>
    <div class="banner-box" id="home" ref="home">
      <div class="banner-text">
        <div class="title">About Us</div>
        <div class="text">
          A company dedicated to relentlessly pursuing innovation, achieving
          customer success, and creating value.
        </div>
      </div>
    </div>
    <div class="mission-box">
      <div class="content">
        <div class="title">
          Personalized customization, expanding brand horizons
        </div>
        <div class="text">
          We can tailor a personalized package according to your company's needs
          to meet your unique requirements. Our clients span across various
          industries including service, real estate, catering, e-commerce, and
          non-profit organizations. Let's collaborate to pave new paths for your
          brand.
        </div>
      </div>
      <img src="../assets/mession-1.png" alt="" />
    </div>
    <div class="plan-box">
      <div class="item">
        <img src="../assets/plan-1.png" alt="" />
        <div class="title">
          35+
        </div>
        <div class="text">
          Industry Domains
        </div>
      </div>
      <div class="item">
        <img src="../assets/plan-2.png" alt="" />
        <div class="title">
          83,000+
        </div>
        <div class="text">
          Distinctive Creativity
        </div>
      </div>
      <div class="item">
        <img src="../assets/plan-3.png" alt="" />
        <div class="title">
          100+
        </div>
        <div class="text">
          Outstanding Solutions
        </div>
      </div>
    </div>
    <div class="number-box">
      <div class="title">
        With a robust advertising strategy team, we provide comprehensive brand
        building and promotion services.
      </div>
    </div>
    <div class="mission-box mission-box-1">
      <img src="../assets/mession-2.png" alt="" />
      <div class="content">
        <div class="title">
          Our team boasts years of rich experience.
          
        </div>
        <div class="text">
          We provide solutions tailored to your business positioning.
        </div>
        <div class="list">
          <div class="item">
            <div class="tit">
              Creativity
            </div>
            <div class="process">
              <div class="number">
                100%
              </div>
              <div class="white-box">
                <p class="color-box"></p>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="tit">
              Uniqueness
            </div>
            <div class="process">
              <div class="number">
                100%
              </div>
              <div class="white-box">
                <p class="color-box"></p>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="tit">
              Astonishment
            </div>
            <div class="process">
              <div class="number">
                100%
              </div>
              <div class="white-box">
                <p class="color-box"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.banner-box {
  background-image: url(../assets/swiper-2.png);
  height: 450px;
  background-size: 100% 100%;
  margin-top: -84px;
  .banner-text {
    margin: 0 360px;
    padding-top: 200px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 64px;
      color: #ffffff;
      width: 650px;
    }

    .text {
      font-size: 26px;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
      width: 500px;
      margin-top: 20px;
    }
  }
}

.mission-box {
  padding: 150px 360px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .content {
    width: 500px;
    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 46px;
      color: #333333;
      line-height: 50px;
    }
    .text {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 24px;
      color: #999999;
      margin-top: 20px;
    }
  }
  img {
    width: 617px;
    height: 430px;
  }
}
.plan-box {
  padding: 100px 360px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0;
  .item {
    text-align: left;
    width: 250px;
    height: 280px;
    img {
      width: 52px;
      height: 56px;
      margin-top: 36px;
    }
    .title {
      font-family: Roboto, Roboto;
      font-weight: 600;
      font-size: 50px;
      color: #333333;
    }
    .text {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 20px;
      color: rgba(51, 51, 51, 0.8);
    }
  }
}
.number-box {
  padding: 0 360px;
  height: 393px;
  background: url(../assets/number-bg.png) 100% no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  .title {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 600;
    font-size: 50px;
    color: #fff;
    margin-top: 80px;
  }
}

.mission-box-1 {
  justify-content: space-between;
  background: #f6f6f6;
  padding-right: 300px;
  align-items: flex-start;
  img {
    width: 597px;
    height: 468px;
  }
  .content {
    width: 600px;
    .list {
      margin-top: 50px;
      .tit {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: #777777;
        margin-bottom: 20px;
      }
      .item {
        margin-bottom: 20px;
        position: relative;
        .number {
          position: absolute;
          right: 0;
          top: 20px;
          font-family: Roboto, Roboto;
          font-weight: bold;
          font-size: 18px;
          color: #263959;
        }
        .white-box {
          width: 100%;
          height: 16px;
          background-color: #fff;

          p {
            width: 100%;
            height: 16px;
            background-color: #0459d8;
          }
        }
      }
    }
  }
}
</style>
